module.exports = global["Phaser"] = require("-!F:\\Projects\\PressPausePlay\\EDF Power Patrol\\node_modules\\uglify-loader\\index.js!.\\phaser.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser/dist/phaser.js-exposed
// module id = 18
// module chunks = 0